import { Component, OnInit } from '@angular/core';
import { NgxCarousel } from 'ngx-carousel';
import {MainService} from "../../services/main.service";
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import 'rxjs/add/operator/switchMap';

@Component({
  selector: 'app-test',
  templateUrl: './test.component.html',
  styleUrls: ['./test.component.css']
})
export class TestComponent implements OnInit {

		public carouselOne: NgxCarousel;

  constructor(private mService:MainService) { }

  news:any;
  event:any;
  notice:any;

  ngOnInit() {


    this.mService.getNewsList().subscribe((result:any)=>{
      this.news = result;
    });

    this.mService.getEventList().subscribe((result:any)=>{
      this.event = result;
    });

    this.mService.getNoticeList().subscribe((result:any)=>{
      this.notice = result;
    });






  	this.carouselOne = {
      grid: {xs: 1, sm: 1, md: 1, lg: 1, all: 0},
      slide: 1,
      speed: 400,
      interval: 4000,
      point: {
        visible: true
      },
      load: 2,
      touch: true,
      loop: true,
      custom: 'banner'
    }
  }


}



// WEBPACK FOOTER //
// ./src/app/components/test/test.component.ts